"use strict";

import angular from "angular";

import template from "./chart-column-comparation.component.html";
import "./chart-column-comparation.component.scss";

import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";

class ChartColumnComparationComponent {
    constructor($filter) {
        this.FormatUnits = new FormatUnits($filter);
    }

    $onInit() {
        this._setVisualization();
    }

    _setVisualization() {
        if (!this.configs) return;

        const formatValue = this.FormatUnits.formatValue;
        const structure = {
            chart: {
                category: "columncomparation",
                chart: {
                    reflow: true
                },
                tooltip: {
                    formatter: function () {
                        return `${this.key}: ${formatValue(
                            "currency",
                            this.y
                        )} `;
                    }
                },
                series: this.configs.series,
                yAxis: {
                    title: {
                        text: ""
                    }
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    categories: ["TOTAL DE RECURSOS"],
                    title: {
                        text: ""
                    },

                    labels: {
                        enabled: false
                    }
                },
                labels: {
                    items: [
                        {
                            style: {
                                left: "50px",
                                top: "18px",
                                color: "rgb(48, 206, 212)"
                            }
                        }
                    ]
                },
                plotOptions: {
                    column: {
                        stacking: "normal",
                        cursor: "pointer"
                    }
                }
            }
        };

        if (
            this.goals &&
            this.visualizationData?.component?.configs?.goals?.length
        ) {
            structure.chart.goals =
                this.visualizationData?.component?.configs?.goals;
        }

        this.visualization = structure;
    }
}

ChartColumnComparationComponent.$inject = ["$filter"];

const name = "chartColumnComparationComponent";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<"
    },
    controller: ChartColumnComparationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
